const isLocal = typeof window !== 'undefined' && window.location.hostname === '0.0.0.0';

// When deployed, API calls are same-origin (empty base): CloudFront routes
// `/${stage}/*` to the API gateway. Locally, point at the beta JP host.
export const API_ENDPOINT = isLocal
    ? 'https://beta.jp.capacity-central.amzl.amazon.dev'
    : '';

export const STAGE = (() => {
    const config: Record<string, string> = typeof (globalThis as any).__CONFIG__ !== 'undefined'
        ? (globalThis as any).__CONFIG__
        : {};
    return config.Stage || 'beta';
})();

export const REGION = 'us-west-2';
export const MARKETPLACE = 'jp';

// First path segment of every API route — matches the API Gateway stage name.
export const API_STAGE = STAGE === 'prod' ? 'prod' : 'beta';

// The only business Bogyo serves today.
export const DEFAULT_BUSINESS = 'ssd';
export const BUSINESSES = ['ssd'];
